import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory } from 'react-router-dom';
import data from "../../../../assets/apiRoutes.json";
import ArrayStore from 'devextreme/data/array_store';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import FormField from '../../../../dynamicFormBuilder/FormField'
import axios from "axios";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { DetailsLayout, HeaderLayout, MiscLayout, PrimaryLayout, PrintFormatLayout } from './Layout';
import Toast from 'devextreme/ui/toast';
import { alert, confirm } from 'devextreme/ui/dialog';
import { custom } from 'devextreme/ui/dialog';
import PrimaryTab from "./tabs/PrimaryTab";
import HeaderTab from "./tabs/HeaderTab";
import DetailsTab from "./tabs/DetailsTab";
import PrintFormatTab from "./tabs/PrintFormatTab";
import MiscTab from "./tabs/MiscellaneousTab";
import DefaultsTab from "./tabs/DefaultsTab";
import ValidationSummary from 'devextreme-react/validation-summary';
import AccountingTab from "./tabs/AccountingTab";
import { v4 as uuidv4 } from 'uuid';
import form from "../../../../wm/components/transactions/dataentry/form";
import { ItemTypes, LokupOptions, Options, PriceLevels, RecordTypes, TransactionStage, TransactionStatus, TransactionTypes } from "../../../../enum/Enum";
import { OM } from "../../../../const/constants";
import { LotCodeDefaultMethodOptions } from "../../../../enum/TransactionDataEntryEnum";
import { MESSAGES } from "../../../../common/Messages";


function Form(props) {
    const initialFormFields = {
        Record: null,
        RowId: '00000000-0000-0000-0000-000000000000',
        CreationDatetime: null,
        CreationUserId: null,
        LastUpdateDatetime: null,
        LastUpdateUserId: null,
        CompanyId: null,
        Module: null,
        RecordType: null,
        ProfileCode: null,
        Description: null,
        Comment: null,
        RTransactionHeader: null,
        AccessUnitPrice: 'Y',
        LotCodeDefaultMethod: null,
        AccessProductCategory: 'Y',
        AccessPriceLevel: 'Y',
        AccessTermsCode: 'Y',
        AccessTaxCode: 'Y',
        AccessTaxableFlag: 'Y',
        ItemAvailableWindow: null,
        AccessBackOrderQuantity: 'C',
        CustomerCreditLimit: 'N',
        ConfirmUserId: null,
        TransactionNumberMethod: null,
        PriceBasis: 'N',
        ShowPrintWarning: null,
        PriceLevelWarning: 'N',
        RDiscountAccount: null,
        RDiscountDepartment: null,
        RDiscountActivity: null,
        ShipmentIdMethod: null,
        Factored: null,
        TransactionCreditLimit: null,
        MonthlyCreditLimit: null,
        UseLocation: null,
        UserDefinedCode1: null,
        UserDefinedCode2: null,
        UserDefinedCode3: null,
        UserDefinedCode4: null,
        UserDefinedCode5: null,
        PopupMessage: null,
        SalesPersonWarning: 'N',
        ItemSalesDates: 'N',
        AccessLocationGrid: 'Y',
        RPODefaultProfile: null,
        RShipper: null,
        LotMethodShipments: 'M',
        LotPickSequenceShipments: null,
        BoTransactionNumberMethod: 'N',
        LotSelectionTiming: null,
        RDiscountJob: null,
        RDiscountFund: null,
        AllowNegAvlItem: null,
        FromStageItem: null,
        AllowNegAvlLocation: null,
        FromStageLocation: null,
        LocationMethod: 'M',
        LocationPickMethod: null,
        LocationPickSequence: null,
        StatusCheckFuture: null,
        StatusCheckPending: 'D',
        StatusCheckAssigned: 'D',
        StatusCheckPicked: 'D',
        StatusCheckCompleted: 'D',
        StatusCheck: null,
        OriginalOrderQuantityTiming: 'A',
        OriginalOrderQuantityAccess: 'Y',
        OmPrefix: 'A',
        FMTransferTiming: 'A',
        DefaultTerms: 'A',
        DefaultTax: 'A',
        DefaultPriceLevel: 'A',
        RDefaultWh: null,
        DefaultSalesPerson: 'A',
        StageWarning: 'N',
        StageWarningComment: null,
        CreditCheckOnStageChange: 'N',
        ACCommitUnits: null,
        SpTransactionDateFlag: null,
        DefaultFxData: 'P',
        SpReferenceFieldFlag: null,
        UseLineNumbers: null,
        UseAlternateDescription: null,
        DiscountBasis: 'I',
        AllowDuplicatePo: null,
        LineNumberIncrement: null,
        ShipToLookup: 'C',
        ArTradeDiscountFlag: null,
        UnitOfMeasure: null,
        ArTermsDiscountFlag: null,
        UserDefinedCodeDetail1: null,
        UserDefinedCodeDetail2: null,
        UserDefinedCodeDetail3: null,
        UserDefinedCodeDetail4: null,
        UserDefinedCodeDetail5: null,
        ReadOnlyWebFromStage: null,
        PresetLotCode: null,
        CheckKitAvailability: null,
        DefaultReportFormats: null,
        KitDetailUsage: null,
        PONumberMethod: null,
        PONumberFrom: null,
        PONumberTo: null,
        PONumberLast: null,
        PONumberExpiration: null,
        PONumberIncrement: null,
        ItemVisibility: null,
        ArDescriptionFlag: null,
        KitDetailUsageAdjustment: null,
        RDefaultLocationWh: null,
        RRequisitionDefaultProfile: null,
        ConsigneePriceScheduleWh: null,
        CustomerPriceScheduleWh: null,
        CheckDuplicateItems: null,
        RImportLayout: null,
        Approval: null,
        DiscPriceWarning: 'N',
        UseCommitDateForFyfp: 'N',
        AssociateSalesPeople: null,
        UseQuantity: 'A',
        UnitPriceFromDate: 'A',
        UseQuantityChange: 'B',
        CheckDuplicateTrans: null,
        SeparateFreight: null,
        DefaultInvDate: null,
        QuantityCheck: 'A',
        DateValidation: null,
        AllowUserValidation: null,
        CreateDoContents: 'N',
        POReqDropShip: null,
        POReqBackOrdered: null,
        POReqPurchased: null,
        POReqOrdered: null,
        PrintToPrinterEditReport: null,
        PrintToPrinterPickingSlip: null,
        PrintToPrinterPackingSlip: null,
        PrintToPrinterInvoice: null,
        PrintToPrinterOrderAcknowledge: null,
        RLayoutId: null,
        BoStatus: 'O',
        PosCategory1: null,
        PosCategory2: null,
        PosCategory3: null,
        PosCategory4: null,
        PosCategory5: null,
        PosCategory6: null,
        RNonInvProductCategory: null,
        PosCategory7: null,
        PosCategory8: null,
        PosCategory9: null,
        PosCategory10: null,
        PosCategory11: null,
        PosCategory12: null,
        PosGiftCategory: null,
        PosNewGiftCard: null,
        PosAddValueGiftCard: null,
        UseDiscountFromVcr: null,
        DisplayDiscountFromVcr: null,
        DateValidationUdDates: null,
        ItemLotNetAvailWarning: 'N',
        SelectItemsFilter1: null,
        SelectItemsFilter2: null,
        SelectItemsFilter3: null,
        SelectItemsFilter4: null,
        RapidEntry: null,
        RapidEntryStage: null,
        AccessFreight: null,
        AutoCalcFreight: null,
        RChargeCodeFreight: null,
        PtrAssignedStageFlag: null,
        InventoryReview: null,
        ItemBuilderFlag: null,
        RItemBuilderConfig: null,
        FMTransferStage: 'N',
        IncludeDiscountInUnitPrice: 'N',
        DetailStatus: 'A',
        DisplayCustomFees: 'Y',
        DisplayCustomFeesTab: 'N',
        UserCustomFeesP: null,
        SplitOption: 'S',
        ImportDetailLineStage: null,
    };
    const yesNoOptions = [{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }]
    const noYesOptions = [{ id: 'N', name: 'No' }, { id: 'Y', name: 'Yes' }]
    const [formFields, setformFields] = useState(initialFormFields);
    const [reportFormFields, setReportFormFields] = useState({
        PickSlipFormat: null,
        InvoiceFormat: null,
        OrderAcknFormat: null,
        PickSlipFormat2: null,
        EditReportFormat: null,
        ARFormat: null,
    });
    const formFieldsRef = useRef({});
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const editReport = [
        { id: uuidv4(), name: 'Standard Abecas', description: 'rptOMSalesOrder' },
        { id: uuidv4(), name: 'Control Log', description: 'rptrptOMSalesOrderControlLog' },
    ];
    const standardPickSlip = [
        { id: uuidv4(), name: 'Standard Abecas Item W/Location', description: 'rptStandardAbecasItemLocation' },
        { id: uuidv4(), name: 'Standard Abecas Item Lot W/Location', description: 'rptStrdAbecasItemLotLocation' },
        { id: uuidv4(), name: 'Standard Abecas Item W/No Location', description: 'rptStandardAbecasItem' },
        { id: uuidv4(), name: 'Standard Abecas Item Lot W/No Location', description: 'rptStandardAbecasItemLot' },
        { id: uuidv4(), name: 'Standard Abecas ItemLot OrderBy Location', description: 'rptStdByLocation' }
    ];
    const standardPickSlip2 = [
        { id: uuidv4(), name: 'Standard Abecas', description: 'rptOMPackingSlip' },
    ];
    const standardInvoice = [
        { id: uuidv4(), name: 'Standard Abecas', description: 'rptInvoice' },
        { id: uuidv4(), name: 'Standard Abecas with No Headings', description: 'rptDotMatrix1Invoice' },
        { id: uuidv4(), name: 'Standard Abecas with Price Schedule', description: 'rptInvoice_PSched' },
        { id: uuidv4(), name: 'Standard Abecas by Item', description: 'rptInvoice_ByItem' },
        { id: uuidv4(), name: 'Standard Abecas with Component Codes', description: 'rptInvoiceRebates' }
    ];
    const standardOrdAck = [
        { id: uuidv4(), name: 'Standard Abecas', description: 'rptOrderAcknowledgement' },
        { id: uuidv4(), name: 'McKay Format', description: 'rptMcKayNursery' },
        { id: uuidv4(), name: 'Standard Lot Format', description: 'rptOrderLotAck' }
    ];
    const arReport = [
        { id: uuidv4(), name: 'Standard Abecas', description: 'rptAging1' },
        { id: uuidv4(), name: 'Five Break Format', description: 'rptAging2' },
        { id: uuidv4(), name: 'Standard Abecas - Landscape', description: 'rptAging1_Landscape' },
        { id: uuidv4(), name: 'Five Break Format - Landscape', description: 'rptAging2_Landscape' }

    ];
    const handleFormSubmit = async (e) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            e.preventDefault();
            console.log(formFields);
            if (formFields.RowId == "00000000-0000-0000-0000-000000000000") {
                await postTransaction();
            }
            else {
                await updateTransaction();
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const postTransaction = async () => {
        try {
            const url = "om/TransactionDp/InsertSalesOrderProfile";
            let fields = formFields;
            fields.DefaultReportFormats = getFormats();
            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data.ERRORS.length > 0) {

                setformFields(prevFields => ({
                    ...prevFields,
                    RowId: response.data.ROWID,
                    Record: response.data.RECORD,
                }));

                notify(
                    {
                        message: "Sales Order Data Profile Created",
                        width: 600,
                    },
                    'success',
                    3000,
                );
                //(false);
            } else {
                const errorHtml = response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const updateTransaction = async () => {
        try {
            const url = "om/TransactionDp/UpdateSalesOrderProfile";
            let fields = formFields;
            fields.DefaultReportFormats = getFormats();
            const response = await axios.put(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data.ERRORS.length > 0) {

                notify(
                    {
                        message: "Sales Order Data Profile Updated",
                        width: 600,
                    },
                    'success',
                    3000,
                );

            } else {
                const errorHtml = response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const loadLookupClient = (name, data) => {
        try {
            if (formRefs.current[name]) {
                formRefs.current[name].instance().option('dataSource', data);
                formRefs.current[name].instance().option('valueExpr', 'id');
                formRefs.current[name].instance().option('displayExpr', 'name');
            }
        } catch (error) {
            console.error('Error fetching item detail:', error);
        } finally {
        }
    };
    const loadLookupFromDataSource = (formRefs, name, url, valueExpr, displayExpr, loadParams = null) => {
        var dataSource = new DataSource({
            store: new createStore({
                key: valueExpr,
                loadUrl: url,
                loadParams: loadParams,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: displayExpr, desc: false }],
            paginate: true,
            pageSize: 100
        });
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', valueExpr);
            formRefs.current[name].instance().option('displayExpr', displayExpr);
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }
    };

    const handleReset = () => {
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else {
            setformFields(initialFormFields);
            EnableControlsForNewRecord();
        }
    };
    const GetHeaderInfoById = (id) => {
        try {
            setLoadPanelVisible(true);
            const response = axios.get(`${window._env_.REACT_APP_APIS}/om/TransactionDp/GetSalesOrderProfile?rowid=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                const responseData = res.data;
                if (responseData.RowId) {
                    setformFields(responseData);
                }
                else {
                    console.error('Failed to get transaction data');
                }
            });


        } catch (error) {
            console.error('Error failed to get transaction data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
    const EnableControlsForNewRecord = () => {
        setformFields(initialFormFields);
        DisableEnableControls(true);
    }
    const DisableEnableControls = (value) => {
        if (formRefs.current['LotCodeDefaultMethod']) {
            formRefs.current['LotCodeDefaultMethod'].instance().option('disabled', value);
        }
        if (formRefs.current['LotPickSequenceShipments']) {
            formRefs.current['LotPickSequenceShipments'].instance().option('disabled', value);
        }
        if (formRefs.current['LotSelectionTiming']) {
            formRefs.current['LotSelectionTiming'].instance().option('disabled', value);
        }
        if (formRefs.current['LocationPickMethod']) {
            formRefs.current['LocationPickMethod'].instance().option('disabled', value);
        }
        if (formRefs.current['FromStageLocation']) {
            formRefs.current['FromStageLocation'].instance().option('disabled', value);
        }
    }
    useEffect(() => {
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else {
            EnableControlsForNewRecord();
        }
    }, [props.id]);
    useEffect(() => {
        formFieldsRef.current = formFields;
    }, [formFields]);
    const goBack = () => {
        history.push("/om/data-profiles/salesorder-profile-data-entry");
    };
    const goToDefaultTransaction = async () => {
        try {
            setLoadPanelVisible(true);
            let rowId = await GetOmTransactionHeaderByProfile(formFields.RowId);
            if (!rowId)
                insertTransacation();
            else {
                const params = new URLSearchParams({
                    id: rowId,
                    RProfile: formFields.RowId,
                    RecordType: RecordTypes.Profile
                });
                history.push(`/om/transactions/salesorders/edit-salesorder?${params.toString()}`);
            }
        } catch (error) {
            alert(error, MESSAGES.ERROR_FORM_SUBMISSION);
        }
        finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
        const GetOmTransactionHeaderByProfile = async (id) => {
        try {
          let response = await axios.get(`${window._env_.REACT_APP_APIS}/om/SaleOrder/GetSalesOrderHeader?ProfileRowId=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });
            if (response.data) {
                return response.data.RowId;
            }
            return null;
        } catch (error) {
            console.error('Error failed to get transaction data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
    const insertTransacation = async () => {
        try {
            const url = "om/transaction/PostTransaction";
            let fields = {
                R_PROFILE: formFields.RowId,
                MODULE: OM,
                RECORDTYPE: RecordTypes.Profile,
                TRANSACTIONTYPE: TransactionTypes.Invoice,
                TRANSACTIONDATE: new Date(),
                PRICELEVEL: PriceLevels.PriceLevelA,
                STATUS: TransactionStatus.Open, 
                PICKSTATUS: null,
                DISCOUNTTYPE: Options.No,
                ORDERSIGNEDFLAG: Options.Yes,
                SHIPPINGDATE: new Date(),
                PRINTINVOICE: Options.Yes,
                PRINTBOL: Options.Yes,
                PRINTDELIVERYNOTIFICATION: Options.Yes,
                PRINTORDERACKNOWLEDGEMENT: Options.Yes,
                SENDFAX: Options.No,
                SENDEMAIL: Options.No,
                PARTIALSHIPMENT: Options.Yes,
                PRINTPICKINGSLIP: Options.Yes,
                PRINTPACKINGSLIP: Options.Yes,
                COMMISSIONTYPE: Options.No,
                FMTRANSFERFLAG: Options.No,
                STAGE: TransactionStage.Picked,
                BACKORDERFLAG: Options.No,
                TRANSACTIONSUBTYPE:  TransactionStatus.Open,
                EDITRANSMITFLAG: Options.No,
                COMMITTYPE: Options.No,
                TRANSCURRENCYTYPE: TransactionStatus.Hold,
                PAYCURRENCYTYPE: TransactionStatus.Hold,
                CONSIGNMENT: Options.No,
                MISCFEETYPE:TransactionTypes.Adjustment,
                CHARGEANDHOLDTYPE: TransactionTypes.Adjustment,
                CREDITSTATUSREVIEW: Options.No,
                INVENTORYREVIEW: Options.No,
                HOLDATALTERNATEWH: Options.No,
                CREATEORDERATALTERNATEWH: Options.No,
                CANCELLED: TransactionStatus.Open,
            };
            setLoadPanelVisible(true);
            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (response.data) {
                history.push("/om/transactions/salesorders/edit-salesorder?id=" + response.data.ROWID+'&RProfile='+formFields.RowId);
            }
        } catch (error) {
            console.error(MESSAGES.ERROR_FORM_SUBMISSION, error);
            throw error;
        }
    };
    const addNewRecordClick = () => {
        setformFields(initialFormFields);
        history.push('/om/data-profiles/salesorder-profile-data-entry-create');
    };

    const handleFieldChange = useCallback((name, value, e) => {

    }, []);
    const disableEnableOnHandleChange = (name,value,isNull)=>{
        if (isNull) {
            setformFields(prevFields => ({
                ...prevFields,
                [name]: null,
            }));
        }
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('disabled', value);
        }
    };
    const handleSelectionChange = useCallback((name, e) => {
        if (name == 'LocationMethod') {
            disableEnableOnHandleChange('LocationPickMethod', e.selectedItem?.id === LokupOptions.Manually ? true : false, true);
            disableEnableOnHandleChange('LocationPickSequence', e.selectedItem?.id === LokupOptions.Manually ? true : false, true);
            disableEnableOnHandleChange('FromStageLocation', e.selectedItem?.id === LokupOptions.Manually ? true : false, true);
        }
        if (name == 'LotMethodShipments') {
            disableEnableOnHandleChange('LotCodeDefaultMethod', e.selectedItem?.id === LokupOptions.Manually ? true : false, true);
            disableEnableOnHandleChange('LotPickSequenceShipments', e.selectedItem?.id === LokupOptions.Manually ? true : false, true);
            disableEnableOnHandleChange('LotSelectionTiming', e.selectedItem?.id === LokupOptions.Manually ? true : false, true);
        }
        if (name === 'AutoCalcFreight') {
            disableEnableOnHandleChange('RChargeCodeFreight', e.selectedItem?.id === Options.No ? true : false, true);
        }
        if (name === 'KitDetailUsage') {
            disableEnableOnHandleChange('KitDetailUsageAdjustment', e.selectedItem?.id === LokupOptions.NotUsed ? true : false, true);
        } if (name === 'RapidEntry') {
            disableEnableOnHandleChange('RapidEntryStage', e.selectedItem?.id === Options.No ? true : false, true);
        }
        if (name === 'ItemBuilderFlag') {
            disableEnableOnHandleChange('RItemBuilderConfig', e.selectedItem?.id === Options.No ? true : false, true);
        }
        const text = e.selectedItem?.name;
        const formatCaption = e.selectedItem?.description;
        const chargeuom = e.selectedItem?.chargeuom === undefined ? 0 : 1;

        if (text != null && text !== '' && formatCaption !== null) {
            let format = `${chargeuom}||${text}||${formatCaption}`;
            if (name == 'EditReportFormat') {
                setReportFormFields(prevFields => ({
                    ...prevFields,
                    EditReportFormat: format,
                }
                ));
            }
            if (name == 'PickSlipFormat2') {
                setReportFormFields(prevFields => ({
                    ...prevFields,
                    PickSlipFormat2: format,
                }
                ));
            }
            if (name == 'PickSlipFormat') {
                setReportFormFields(prevFields => ({
                    ...prevFields,
                    PickSlipFormat: format,
                }
                ));
            }
            if (name == 'InvoiceFormat') {
                setReportFormFields(prevFields => ({
                    ...prevFields,
                    InvoiceFormat: format,
                }
                ));
            }
            if (name == 'OrderAcknFormat') {
                setReportFormFields(prevFields => ({
                    ...prevFields,
                    OrderAcknFormat: format,
                }
                ));
            }
            if (name == 'ARFormat') {
                setReportFormFields(prevFields => ({
                    ...prevFields,
                    ARFormat: format,
                }
                ));
            }
        }
    }, []);
    const handleHeaderFormLoad = useCallback(() => {
        loadLookupClient("AccessPriceLevel", yesNoOptions);
        loadLookupClient("AccessTermsCode", yesNoOptions);
        loadLookupClient("AccessTaxCode", yesNoOptions);
        loadLookupClient("FMTransferTiming", [{ id: 'N', name: 'Not Applicable' }, { id: 'A', name: 'Transfer To FM At Order Entry' }, { id: 'B', name: 'Transfer To FM By Batch' }])
        loadLookupClient("CreateDoContents", [{ id: 'N', name: 'No, do not create Do contents' }, { id: 'Y', name: 'Yes, create Do contents by line item' }, { id: 'I', name: 'Yes, create Do contents with item class code as Type' }])
        loadLookupClient("FMTransferStage", [{ id: 'N', name: 'Pending' }, { id: 'A', name: 'Assigned' }])
        loadLookupClient("CustomerCreditLimit", [{ id: 'N', name: 'No Credit Limit Validation' }, { id: 'A', name: 'Display Credit Limit Against Open Items & Open Orders' }, { id: 'E', name: 'Only Display When Exceeding Credit Limit' }, { id: 'R', name: 'Requires Credit Review Rules' }])
        loadLookupClient("CreditCheckOnStageChange", [{ id: 'N', name: 'No' }, { id: 'F', name: 'Yes - Credit Check From Future Stage' }, { id: 'P', name: 'Yes - Credit Check From Pending Stage' }, { id: 'R', name: 'Yes - Credit Check From Ready Stage' }, { id: 'C', name: 'Yes - Credit Check From Completed Stage' }])
        loadLookupClient("BoTransactionNumberMethod", [{ id: 'N', name: 'No, Use Original Transaction #' }, { id: 'S', name: 'No, Use Original Transaction # - Append Two Digit Sequence # to the end (eg: -01)' }, { id: 'T', name: 'No, Do Not Generate Back Order Transaction' }, { id: 'Y', name: 'Yes, Create New Transaction #' }])
        loadLookupClient("BoStatus", [{ id: 'O', name: 'Open' }, { id: 'L', name: 'Ready to Commit Later' }])
        loadLookupClient("DiscountBasis", [{ id: 'E', name: 'Exclude Misc. Fees' }, { id: 'I', name: 'Include Everything' }])
        loadLookupClient("Approval", [{ id: 'A', name: 'No approval required' }, { id: 'B', name: 'Yes only when ' }, { id: 'C', name: 'Yes, based on customer credit limit.' }])
        loadLookupClient("AllowDuplicatePo", [{ id: 'N', name: 'No' }, { id: 'Y', name: 'Yes' }, { id: 'W', name: 'Warning Only' }, { id: 'A', name: 'No, but only if for same customer' }, { id: 'B', name: 'Warning when transaction is for same customer' }])
        loadLookupClient("SalesPersonWarning", [{ id: 'N', name: 'No, Do Not Give Warning When Customer Has No Salesperson in AR Customer Master' }, { id: 'Y', name: 'Yes, Give Warning When Customer Has No Salesperson in AR Customer Master' }])
        loadLookupClient("StageWarning", [{ id: 'N', name: 'No, Do Not Show Warning When Detail Record Is Changed For Assigned & Picked Stages' }, { id: 'Y', name: 'Yes, Show Warning When Detail Record Is Changed For Assigned & Picked Stages' }])
        loadLookupClient("UseDiscountFromVcr", [{ id: 'N', name: 'No' }, { id: 'Y', name: 'Yes, use Cost Components from VCR' }])
        loadLookupClient("DisplayDiscountFromVcr", [{ id: 'N', name: 'No' }, { id: 'Y', name: 'Yes, display discount details If any exist' }, { id: 'A', name: 'Yes, always display discount' }])
        loadLookupClient("DateValidation", [{ id: 'N', name: 'No, do not execute user validation stored procedure' }, { id: 'Y', name: 'Yes, execute user validation stored procedure' }, { id: 'C', name: 'Yes, execute user validation stored procedure and allow cancel' },
        { id: 'D', name: 'Yes, execute user validation stored procedure upon display' }, { id: 'O', name: 'Yes, execute user validation stored procedure for header and detail and show warning' }, { id: 'B', name: 'Yes, execute user validation stored procedure for header and detail and allow cancel' }])
        loadLookupClient("ShipToLookup", [{ id: 'C', name: 'Display From Customer Master' }, { id: 'A', name: 'Display All Ship TO Codes' }])
        loadLookupClient("StatusCheck", [{ id: 'Y', name: 'Allow all status regardless the stage' }, { id: 'N', name: 'Only allow the status to be set to Ready to Commit if the stage is Completed/Cancelled' }])
        loadLookupClient("CheckDuplicateTrans", [{ id: 'N', name: 'Do not allow duplication trans#' }, { id: 'W', name: 'User choses to allow duplicated trans#' }, { id: 'Y', name: 'Allow duplicate trans#' }])
        loadLookupClient("AllowUserValidation", [{ id: 'N', name: 'No, do not execute user validation stored procedure' }, { id: 'Y', name: 'Yes, execute user validation stored procedure' }, { id: 'C', name: 'Yes, execute user validation stored procedure and allow cancel' }, { id: 'D', name: 'Yes, execute user validation stored procedure upon display' },
        { id: 'O', name: 'Yes, execute user validation stored procedure for header and detail and show warning' }, { id: 'B', name: 'Yes, execute user validation stored procedure for header and detail and allow cancel' }])
        loadLookupClient("UseCommitDateForFyfp", [{ id: 'N', name: 'No, Use FY/FP from Transaction Date' }, { id: 'Y', name: 'Yes, Use FY/FP from Commit Date' }])
        loadLookupClient("DetailStatus", [{ id: 'A', name: 'Inventory & Non-Inventory (Default)' }, { id: 'I', name: 'Inventory Only' }])
        loadLookupClient("SplitOption", [{ id: 'S', name: 'Simple' }, { id: 'A', name: 'Advanced' }])
    }, []);
    const handlePrimaryFormLoad = useCallback(() => {

    }, []);
    const handleDetailsFormLoad = useCallback(() => {
        loadLookupClient("StatusCheckPending", [{ id: 'A', name: 'Display All Items/Lots - Warn & Allow User TO Proceed' }, { id: 'B', name: 'Display All Items/Lots - Do Not Allow User TO Proceed' }, { id: 'C', name: 'Display All Items/Lots With Available Quantites Only - Warn & Allow User To Proceed' },
        { id: 'D', name: 'Display All Items/Lots With Available Quantites Only - Do Not Allow User To Proceed' }, { id: 'E', name: 'None - No Error Checking Required' }])
        loadLookupClient("StatusCheckAssigned", [{ id: 'A', name: 'Display All Items/Lots - Warn & Allow User TO Proceed' }, { id: 'B', name: 'Display All Items/Lots - Do Not Allow User TO Proceed' }, { id: 'C', name: 'Display All Items/Lots With Available Quantites Only - Warn & Allow User To Proceed' },
        { id: 'D', name: 'Display All Items/Lots With Available Quantites Only - Do Not Allow User To Proceed' }, { id: 'E', name: 'None - No Error Checking Required' }])
        loadLookupClient("StatusCheckPicked", [{ id: 'A', name: 'Display All Items/Lots - Warn & Allow User TO Proceed' }, { id: 'B', name: 'Display All Items/Lots - Do Not Allow User TO Proceed' }, { id: 'C', name: 'Display All Items/Lots With Available Quantites Only - Warn & Allow User To Proceed' },
        { id: 'D', name: 'Display All Items/Lots With Available Quantites Only - Do Not Allow User To Proceed' }, { id: 'E', name: 'None - No Error Checking Required' }])
        loadLookupClient("StatusCheckCompleted", [{ id: 'A', name: 'Display All Items/Lots - Warn & Allow User TO Proceed' }, { id: 'B', name: 'Display All Items/Lots - Do Not Allow User TO Proceed' }, { id: 'C', name: 'Display All Items/Lots With Available Quantites Only - Warn & Allow User To Proceed' },
        { id: 'D', name: 'Display All Items/Lots With Available Quantites Only - Do Not Allow User To Proceed' }, { id: 'E', name: 'None - No Error Checking Required' }])

        loadLookupClient("LocationMethod", [{ id: 'M', name: 'Manually Select Locations' }, { id: 'A', name: 'Auto Select Locations Based On Pick Method' }, { id: 'D', name: 'Auto Default Locations From Item Master Based On Pick Method' }])
        loadLookupClient("LocationPickMethod", [{ id: 'L', name: 'location Code' }, { id: 'P', name: 'Priority Code' }, { id: 'C', name: 'Class Code' }, { id: 'S', name: 'Sub Class Code' }
            , { id: 'F', name: 'Primary Location - Forward Pick' }, { id: 'G', name: 'Primary Location - Replenishment' }, { id: 'H', name: 'Primary Location - Reserve' }, { id: 'I', name: 'Backup Location - Forward Pick' }
            , { id: 'J', name: 'Backup Location - Replenishment' }, { id: 'K', name: 'Backup Location - Reserve' }, { id: 'Q', name: 'Quantity' }
        ])
        loadLookupClient("LocationPickSequence", [{ id: 'A', name: 'Ascending' }, { id: 'D', name: 'Descending' }])
        loadLookupClient("FromStageLocation", [{ id: 'F', name: 'Fututr - No Effect On Net Avaiable' }, { id: 'N', name: 'Pending - Effect Net Available' }, { id: 'A', name: 'Assigned - Effect Available' }, { id: 'S', name: 'Shipped/Completed - Effect Available' }])
        loadLookupClient("PriceLevelWarning", [{ id: 'A', name: 'Price Level - A' }, { id: 'B', name: 'Price Level - B' }, { id: 'C', name: 'Price Level - C' }, { id: 'D', name: 'Price Level - D' }, { id: 'E', name: 'Price Level - E' }, { id: 'N', name: 'None' }])
        loadLookupClient("ItemSalesDates", [{ id: 'Y', name: 'Yes- Give Warning When Shipdate is not Between Item Availabele & Item Expiration Dates' }, { id: 'N', name: 'No - Do Not Error Check Ship Date With Item Date' }, { id: 'A', name: 'Yes- Give Warning When Shipdate is Before Item Availabele Date' }, { id: 'B', name: 'Yes - Do Not Allow Ship Date Before Item Availability Date' },
        { id: 'C', name: 'Yes- Give Warning When Shipdate is Before Lot Availabele Date' }, { id: 'D', name: 'Yes- Give Warning When Shipdate is Not Before Lot Availabele Date' }, { id: 'E', name: 'Yes- Give Warning When Shipdate is Not Between Lot Availabele and Lot Expiration Dates' }
        ])
        loadLookupClient("CheckDuplicateItems", [{ id: 'A', name: 'No - do not error-check for duplicate Item in the same Transaction' }, { id: 'B', name: 'Yes, Warn duplicate Items in the same Transaction' }, { id: 'C', name: 'Yes, Error duplicate Items in the same Transaction' }])
        loadLookupClient("DiscPriceWarning", [{ id: 'N', name: 'No, do not show warning message' }, { id: 'Y', name: 'Yes, show warnig when discount is less than unit price' }])
        loadLookupClient("UseQuantity", [{ id: 'A', name: 'Use Orderd quantity to calculateUnit Price' }, { id: 'B', name: 'Use Original Order qunatity to calculate Unit Price' }, { id: 'C', name: 'Do not change Unit Price on Lot/Qty change.' }])
        loadLookupClient("UseQuantityChange", [{ id: 'B', name: 'Apply to both increase and decreases in quantity' }, { id: 'I', name: 'Apply only to increases' }])
        loadLookupClient("UnitPriceFromDate", [{ id: 'A', name: 'Based On Stage and Trans/Ship Date' }, { id: 'B', name: 'Based On Transaction Date' }, { id: 'C', name: 'Based On Shipping Date' }, { id: 'D', name: 'Based On User Defined Date 1' }])
        loadLookupClient("IncludeDiscountInUnitPrice", noYesOptions)
        loadLookupClient("LotMethodShipments", [{ id: 'M', name: 'Manually Select Lot' }, { id: 'A', name: 'Auto Select Lots based On Pick Method' }, { id: 'D', name: 'Auto Default Lot Based On Pick Method' },
        { id: 'P', name: 'Auto Default Preset Lot Code' }, { id: 'Q', name: 'Auto Select Lots Based On Item Qty & Pick Mthd' }, { id: 'C', name: 'Auto Default Based on Calc Price' }])
        loadLookupClient("LotCodeDefaultMethod", LotCodeDefaultMethodOptions)
        loadLookupClient("LotPickSequenceShipments", [{ id: 'A', name: 'Ascending' }, { id: 'D', name: 'Descending' }])
        loadLookupClient("LotSelectionTiming", [{ id: 'N', name: 'Pending - Effect Net Available' }, { id: 'A', name: 'Assigned - Effect Available' }, { id: 'S', name: 'Shipped/Completed - Effect Available' }, { id: 'C', name: 'Yes- Give Warning When Shipdate is Before Lot Availabele Date' }])
        loadLookupClient("PresetLotCode", [{ id: 'A', name: 'No' }, { id: 'B', name: 'Yes, Warn User of Deficiency but Allow to Proceed' }, { id: 'C', name: 'Yes, Warn User of Deficiency but do NOT Allow to proceed' }, { id: 'D', name: 'Always create quantity to produce' }])
        loadLookupClient("OriginalOrderQuantityTiming", [{ id: 'A', name: 'Default First Enterd Quantity' }, { id: 'B', name: 'Default Assigned Quantity' }, { id: 'C', name: 'Default To Zero & Update From Calculate Advance Program (Commissions)' }])
        loadLookupClient("OriginalOrderQuantityAccess", [{ id: 'Y', name: 'Yes, Allow Access TO Original Quantity' }, { id: 'N', name: 'No, Do Not Allow Access To Original Order Quantity' }])
        loadLookupClient("AccessUnitPrice", yesNoOptions)
        loadLookupClient("AccessProductCategory", yesNoOptions)
        loadLookupClient("AccessTaxableFlag", yesNoOptions)
        loadLookupClient("DisplayCustomFees", yesNoOptions)
        loadLookupClient("DisplayCustomFeesTab", yesNoOptions)
        loadLookupClient("UserCustomFeesP", noYesOptions)
        loadLookupClient("AllowNegAvlLocation", [{ id: 'N', name: 'No, Allocate ONLY Available Quantites' }, { id: 'Y', name: 'Yes, Allocate Remaining Quantity To a BLANK Location If Not Available' }])
        loadLookupClient("AccessLocationGrid", [{ id: 'Y', name: 'Yes, Always Access Location Grid' }, { id: 'N', name: 'No, Never Access Location Grid' }, { id: 'F', name: 'Access From Future Stage Onwards' }, { id: 'P', name: 'Access From Pending Stage Onwards' },
        { id: 'A', name: 'Access From Assigned Stage Onwards' }, { id: 'S', name: 'Access From Picked Stage Onwards' }, { id: 'C', name: 'Access From Completed Stage Onwards' }])
        loadLookupClient("QuantityCheck", [{ id: 'A', name: 'Warn as specified by stage' }, { id: 'B', name: 'Warn as specified but allow to proceed' }, { id: 'C', name: 'Override with no warning' }])
        loadLookupClient("ItemLotNetAvailWarning", [{ id: 'N', name: 'No warning' }, { id: 'Y', name: 'Warn but allow to proceed' }, { id: 'S', name: 'Warn and cannot proceed' }])
    }, []);

    const handleDefaultsFormLoad = useCallback(() => {
        const defCusromer = [{ id: 'A', name: 'Default From Customer' }, { id: 'C', name: 'Default From OM Profile' }];
        const option1 = [{ id: 'A', name: 'Default From Customer' }, { id: 'b', name: 'Override Customer From Ship To If Exists' }, { id: 'C', name: 'Default From OM Profile' }]
        const option2 = [{ id: 'A', name: 'Not Applicable' }, { id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }]
        const option3 = [{ id: 'Y', name: 'Include in requisition' }, { id: 'N', name: 'Do not include in requisition' }]

        loadLookupClient("TransactionNumberMethod", [{ id: 'A', name: 'Auto Generate - No Access' }, { id: 'C', name: 'Auto Generate - Allow Access' }, { id: 'U', name: 'User Entered' },
            { id: 'E', name: 'Always Generate When in Edit Mode and is Blank - Allow Access' }, { id: 'F', name: 'Always Generate When in Edit Mode and is Blank - No Access' }, { id: 'G', name: 'Auto Generate on Save - Allow access.' }
        ])
        loadLookupClient("OmPrefix", defCusromer)
        loadLookupClient("DefaultTerms", defCusromer)
        loadLookupClient("DefaultTax", option1)
        loadLookupClient("DefaultPriceLevel", option1)
        loadLookupClient("DefaultSalesPerson", option1)
        loadLookupClient("DefaultInvDate", [{ id: 'C', name: 'Current Date' }, { id: 'S', name: 'Ship Date' }, { id: 'I', name: 'Invoice Commit Date' }])
        loadLookupClient("DefaultFxData", [{ id: 'P', name: 'Default From Data Profile' }, { id: 'C', name: 'Default From Customer' }])

        loadLookupClient("AccessBackOrderQuantity", [{ id: 'A', name: 'Calculate & Give Access' }, { id: 'B', name: 'Calculate & No Access' }, { id: 'C', name: 'No Back Order & No Access' }, { id: 'D', name: 'No Access - Allocate remaining qty. to a new detail line' }, { id: 'E', name: 'Give Access - Allocate remaining qty. to a new detail line' }])
        loadLookupClient("PriceBasis", [{ id: 'N', name: 'Not Applicable' }, { id: 'L', name: 'Based On Last Price For Customer' }])
        loadLookupClient("ArTradeDiscountFlag", option2)
        loadLookupClient("ArTermsDiscountFlag", option2)

        loadLookupClient("POReqDropShip", option3)
        loadLookupClient("POReqBackOrdered", option3)
        loadLookupClient("POReqPurchased", option3)
        loadLookupClient("POReqOrdered", option3)
    }, []);

    const handleMiscFormLoad = useCallback(() => {
        loadLookupClient("SpTransactionDateFlag", [
            { id: 'T', name: 'OM Order Date' },
            { id: 'I', name: 'OM Invoice Date' },
            { id: 'D', name: 'OM Due Date' }
        ]);
        loadLookupClient("SpReferenceFieldFlag", [
            { id: 'T', name: 'Transaction Number' },
            { id: 'R', name: 'Reference' },
            { id: 'P', name: 'PO Number' }
        ]);
        loadLookupClient("SeparateFreight", [
            { id: 'N', name: 'No' },
            { id: 'A', name: 'Based on Price Level A' }
        ]);
        loadLookupClient("AccessFreight", [
            { id: 'Y', name: 'Yes' },
            { id: 'N', name: 'No' }
        ]);
        loadLookupClient("AutoCalcFreight", [
            { id: 'N', name: 'No' },
            { id: 'Y', name: 'Yes' }
        ]);
        // RChargeCodeFreight is a lookup, not a static dropdown
        loadLookupClient("ACCommitUnits", [
            { id: 'S', name: 'Sales Units' },
            { id: 'A', name: 'AC Standardized Units' }
        ]);
        loadLookupClient("ReadOnlyWebFromStage", [
            { id: 'L', name: 'Canceled - No Inventory Effect' },
            { id: 'Q', name: 'Quote - No Inventory Effect' },
            { id: 'P', name: 'Plan - No Inventory Effect' },
            { id: 'F', name: 'Future - No Effect On Net Available' },
            { id: 'N', name: 'Pending - Effect Net Available' },
            { id: 'A', name: 'Assigned - Effect Available' },
            { id: 'S', name: 'Picked/Staged - Effect Available' },
            { id: 'C', name: 'Shipped/Completed - Effect Available ' }
        ]);
        loadLookupClient("AssociateSalesPeople", [
            { id: 'Y', name: 'Yes, allow association with Customer.' },
            { id: 'N', name: 'No, do not allow association with Customer.' }
        ]);
        // SelectItemsFilter1-4 are text fields, not dropdowns in Delphi, so skip unless you have a lookup
        loadLookupClient("CheckKitAvailability", [
            { id: 'A', name: 'No' },
            { id: 'B', name: 'Yes, Warn User of Deficiency but Allow to Proceed' },
            { id: 'C', name: 'Yes, Warn User of Deficiency but do NOT Allow to Proceed' },
            { id: 'D', name: 'Always create quantity to produce' }
        ]);
        loadLookupClient("KitDetailUsage", [
            { id: 'A', name: 'Not Used' },
            { id: 'B', name: 'Explode Production Item Kit' }
        ]);
        loadLookupClient("KitDetailUsageAdjustment", [
            { id: 'A', name: 'Based on Meeting 100% of Sales Demand' },
            { id: 'B', name: 'Based Only on Relative Share of Output' }
        ]);
        loadLookupClient("ItemVisibility", [
            { id: 'A', name: 'All Items (No Limit)' },
            { id: 'B', name: 'Only Items in Consignee Price Schedule' },
            { id: 'C', name: 'Only Items in Cross Reference' }
        ]);
        loadLookupClient("CustomerPriceScheduleWh", [
            { id: 'Y', name: 'Yes, Match Records Based on Both Warehouse and Item' },
            { id: 'N', name: 'No, Ignore Warehouse and Match Records Based on Item Code Only' }
        ]);
        loadLookupClient("ConsigneePriceScheduleWh", [
            { id: 'Y', name: 'Yes, Match Records Based on Both Warehouse and Item' },
            { id: 'N', name: 'No, Ignore Warehouse and Match Records Based on Item Code Only' }
        ]);
        loadLookupClient("PtrAssignedStageFlag", [
            { id: 'N', name: 'No' },
            { id: 'Y', name: 'Yes' }
        ]);
        loadLookupClient("PONumberMethod", [
            { id: 'A', name: 'Manually Entered' },
            { id: 'B', name: 'Automatically Generated' }
        ]);
        loadLookupClient("ArDescriptionFlag", [
            { id: 'A', name: 'From OM PO #' },
            { id: 'B', name: 'From OM Reference' }
        ]);
        loadLookupClient("UseAlternateDescription", [
            { id: 'N', name: 'No - Do Not Use' },
            { id: 'A', name: 'Yes - Item Code' },
            { id: 'B', name: 'Yes - Item Description 1' },
            { id: 'C', name: 'Yes - Item Description 2' },
            { id: 'D', name: 'Yes - Lot Code' },
            { id: 'E', name: 'Yes - Lot Description 1' },
            { id: 'F', name: 'Yes - Lot Description 2' }
        ]);
        loadLookupClient("UseLineNumbers", [
            { id: 'N', name: 'No' },
            { id: 'I', name: 'Use Internal Line# Counter - With Access' },
            { id: 'G', name: 'Get Next Line# from DB - With Access' },
            { id: 'J', name: 'Use Internal Line# Counter - No Access' },
            { id: 'H', name: 'Get Next Line# From DB - No Access' }
        ]);
        loadLookupClient("RapidEntry", [
            { id: 'N', name: 'No (Default)' },
            { id: 'Y', name: 'Yes' }
        ]);
        loadLookupClient("RapidEntryStage", [
            { id: 'F', name: 'Future - No Effect On Net Available' },
            { id: 'N', name: 'Pending - Effect Net Available' }
        ]);
        loadLookupClient("ItemBuilderFlag", [
            { id: 'N', name: 'No' },
            { id: 'Y', name: 'Yes' }
        ]);
        loadLookupClient("InventoryReview", [
            { id: 'N', name: 'No checking' },
            { id: 'C', name: 'Check against max quantity' },
            { id: 'U', name: 'Custom Checking' }
        ]);
        loadLookupClient("ImportDetailLineStage", [
            { id: 'L', name: 'Canceled - No Inventory Effect' },
            { id: 'Q', name: 'Quote - No Inventory Effect' },
            { id: 'P', name: 'Plan - No Inventory Effect' },
            { id: 'F', name: 'Future - No Effect On Net Available' },
            { id: 'N', name: 'Pending - Effect Net Available' },
            { id: 'A', name: 'Assigned - Effect Available' },
            { id: 'S', name: 'Picked/Staged - Effect Available' },
            { id: 'C', name: 'Shipped/Completed - Effect Available' },
        ]);
    }, []);
    const handlePFFormLoad = useCallback(() => {
        loadLookupFromDataSource(formRefs, "PickSlipFormat", `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`, 'id', 'name', { module: 'frmOMR0002' });
        loadLookupFromDataSource(formRefs, "InvoiceFormat", `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`, 'id', 'name', { module: 'frmOMR0001' });
        loadLookupFromDataSource(formRefs, "OrderAcknFormat", `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`, 'id', 'name', { module: 'frmOMR0000' });
        loadLookupFromDataSource(formRefs, "PickSlipFormat2", `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`, 'id', 'name', { module: 'frmOMR0006' });
        loadLookupFromDataSource(formRefs, "EditReportFormat", `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`, 'id', 'name', { module: 'frmOMR0003' });
        loadLookupFromDataSource(formRefs, "ARFormat", `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`, 'id', 'name', { module: 'frmARR0002' });
        loadLookupClient("PrintToPrinterEditReport", [
            { id: 'Y', name: 'Yes' },
            { id: 'N', name: 'No' }
        ]);
        loadLookupClient("PrintToPrinterPickingSlip", [
            { id: 'Y', name: 'Yes' },
            { id: 'N', name: 'No' }
        ]);
        loadLookupClient("PrintToPrinterPackingSlip", [
            { id: 'Y', name: 'Yes' },
            { id: 'N', name: 'No' }
        ]);
        loadLookupClient("PrintToPrinterInvoice", [
            { id: 'Y', name: 'Yes' },
            { id: 'N', name: 'No' },
            { id: 'T', name: '.Net' },
            { id: 'C', name: 'Yes, but do not check for status' }
        ]);
        loadLookupClient("PrintToPrinterOrderAcknowledge", [
            { id: 'Y', name: 'Yes' },
            { id: 'N', name: 'No' }
        ]);
        extractNames(formRefs);
    }, []);
    const handleAccountingFormLoad = useCallback(() => {
    }, []);

    const getFormats = () => {
        let SReport = '';
        if (reportFormFields.EditReportFormat !== '') {
            SReport += reportFormFields.EditReportFormat + '\r\n';
        }
        else {
            SReport += '\r\n';
        }
        if (reportFormFields.PickSlipFormat !== '') {
            SReport += reportFormFields.PickSlipFormat + '\r\n';
        }
        else {
            SReport += '\r\n';
        }
        if (reportFormFields.PickSlipFormat2 !== '') {
            SReport += reportFormFields.PickSlipFormat2 + '\r\n';
        }
        else {
            SReport += '\r\n';
        }
        if (reportFormFields.InvoiceFormat !== '') {
            SReport += reportFormFields.InvoiceFormat + '\r\n';
        }
        else {
            SReport += '\r\n';
        }
        if (reportFormFields.OrderAcknFormat !== '') {
            SReport += reportFormFields.OrderAcknFormat + '\r\n';
        }
        else {
            SReport += '\r\n';
        }
        if (reportFormFields.ARFormat !== '') {
            SReport += reportFormFields.ARFormat;
        }
        return SReport;
    }

    function extractNames(formRefs) {
        let sReport = formFieldsRef.current.DefaultReportFormats;
        let cleanedReportLines = [];
        if (sReport !== null) {
            const reportLines = sReport.split('\r\n').filter(Boolean);
            cleanedReportLines = reportLines.map(line => {
                const parts = line.split('||');
                return parts.length === 3 ? parts[1] : line;
            });
        }

        setSelectBoxValueByDisplay(formRefs, 'EditReportFormat', (cleanedReportLines[0] ?? "").replace(":ABR0001", "").trim(), editReport);
        setSelectBoxValueByDisplay(formRefs, 'PickSlipFormat', (cleanedReportLines[1] ?? "").replace(":ABR0001", "").trim(), standardPickSlip);
        setSelectBoxValueByDisplay(formRefs, 'PickSlipFormat2', (cleanedReportLines[2] ?? "").replace(":ABR0001", "").trim(), standardPickSlip2);
        setSelectBoxValueByDisplay(formRefs, 'InvoiceFormat', (cleanedReportLines[3] ?? "").replace(":ABR0001", "").trim(), standardInvoice);
        setSelectBoxValueByDisplay(formRefs, 'OrderAcknFormat', (cleanedReportLines[4] ?? "").replace(":ABR0001", "").trim(), standardOrdAck);
        setSelectBoxValueByDisplay(formRefs, 'ARFormat', (cleanedReportLines[5] ?? "").replace(":ABR0001", "").trim(), arReport);

    }
    const setSelectBoxValueByDisplay = async (formRefs, refKey, displayValue, newItems = []) => {
        const instance = formRefs?.current[refKey]?.instance;
        if (!instance || displayValue === null) return;

        const store = instance.option('dataSource');
        const displayExpr = instance.option('displayExpr');
        const valueExpr = instance.option('valueExpr');

        try {
            const existingData = await store?.load();
            const updatedData = [...newItems, ...existingData || []];
            const newStore = new ArrayStore({
                key: 'id',
                data: updatedData,
            });

            // Set new store to the select box
            instance.option('dataSource', newStore);
            const matchedItem = updatedData.find(item => item[displayExpr] === displayValue);
            if (matchedItem) {
                instance.option('value', matchedItem[valueExpr]);
            } else {
                console.warn(`No match found for ${displayValue} in ${refKey}`);
            }
        } catch (error) {
            console.error(`Error loading store for ${refKey}`, error);
        }
    };
    const deleteRecords = useCallback(() => {
        var deleteUrl = "om/TransactionDp/DeleteSalesOrderProfile";
        let result = confirm("<i>Are your sure you want to delete record?</i>", "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                axios.post
                    (
                        `${window._env_.REACT_APP_APIS}/${deleteUrl}`,
                        formFields.RowId,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                access_token: accessToken,
                            },
                        }
                    )
                    .then((res) => {
                        notify(
                            {
                                message: "Sales Order Data Profile Deleted",
                                width: 600,
                            },
                            'success',
                            3000,
                        );
                        goBack();
                    })
                    .catch((err) => {
                    });

            }
        });

    }, [formFields.RowId]);


    return (
        <>
            <div>
                <div className="row dataEntryMainPage">
                    <div className="col-md-12 main-page">
                        <div id="accordion">

                            <LoadPanel
                                shadingColor="rgba(0,0,0,0.4)"
                                position={position}
                                onHiding={hideLoadPanel}
                                visible={loadPanelVisible}
                                showIndicator={true}
                                shading={true}
                                showPane={true}
                                hideOnOutsideClick={false}
                            />
                            <form onSubmit={(e) => handleFormSubmit(e)}>
                                <Toolbar className="header">
                                    <Item location="before">
                                        <div className="title">
                                            <h6
                                                style={{
                                                    color: window._env_.Color2,
                                                    marginLeft: '12px'
                                                }}
                                            >
                                                Enter Transaction Profiles
                                            </h6>
                                        </div>
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={addNewRecordClick} text="New" type="default" />
                                    </Item>
                                    <Item location="after">
                                        <Button
                                            text="Save"
                                            useSubmitBehavior={true}
                                            type="default"
                                            className="accordianButton"
                                        />
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton"
                                            disabled={formFields.RowId === '00000000-0000-0000-0000-000000000000'}
                                            text="Sales Order Defaults" type="default" onClick={goToDefaultTransaction}>
                                        </Button>
                                    </Item>
                                    <Item location="after">
                                        <Button
                                            text="Delete"
                                            type="default"
                                            className="accordianButton"
                                            onClick={deleteRecords}
                                            disabled={formFields.RowId === '00000000-0000-0000-0000-000000000000'}
                                        />
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={goBack} text="Back" />
                                    </Item>

                                </Toolbar>
                                <div className="AccordionItemBody">
                                    <TabPanel className="TabpanelContainer">
                                        <TabItem title="Primary">
                                            <PrimaryTab formRefs={formRefs} formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} handlePrimaryFormLoad={handlePrimaryFormLoad} />
                                        </TabItem>
                                        <TabItem title="Header">
                                            <HeaderTab formRefs={formRefs} formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} handleHeaderFormLoad={handleHeaderFormLoad} />
                                        </TabItem>
                                        <TabItem title="Details">
                                            <DetailsTab formRefs={formRefs} formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} handleDetailsFormLoad={handleDetailsFormLoad} />
                                        </TabItem>
                                        <TabItem title="Defaults">
                                            <DefaultsTab formRefs={formRefs} formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} handleDefaultsFormLoad={handleDefaultsFormLoad} />
                                        </TabItem>
                                        <TabItem title="Accounting">
                                            <AccountingTab formRefs={formRefs} formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} handleAccountingFormLoad={handleAccountingFormLoad} />
                                        </TabItem>
                                        <TabItem title="Miscellaneous">
                                            <MiscTab formRefs={formRefs} formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} handleMiscFormLoad={handleMiscFormLoad} />
                                        </TabItem>
                                        <TabItem title="PRINT FORMATS">
                                            <PrintFormatTab formRefs={formRefs} formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} handlePFFormLoad={handlePFFormLoad} />
                                        </TabItem>
                                    </TabPanel>
                                </div>
                                <div className="row">
                                    <ValidationSummary className="pl-3 pt-1" id="summary" />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>

        </>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(Form);